export const GET_FEATURES = "GET_FEATURES"
export const GET_FEATURES_FAIL = "GET_FEATURES_FAIL"
export const GET_FEATURES_SUCCESS = "GET_FEATURES_SUCCESS"

export const ADD_NEW_FEATURE = "ADD_NEW_FEATURE"
export const ADD_FEATURE_SUCCESS = "ADD_FEATURE_SUCCESS"
export const ADD_FEATURE_FAIL = "ADD_FEATURE_FAIL"

export const UPDATE_FEATURE = "UPDATE_FEATURE"
export const UPDATE_FEATURE_SUCCESS = "UPDATE_FEATURE_SUCCESS"
export const UPDATE_FEATURE_FAIL = "UPDATE_FEATURE_FAIL"

export const DELETE_FEATURE = "DELETE_FEATURE"
export const DELETE_FEATURE_SUCCESS = "DELETE_FEATURE_SUCCESS"
export const DELETE_FEATURE_FAIL = "DELETE_FEATURE_FAIL"





